import axiosInstance from "../utils/authUtils";
import { API_PATHS } from "../utils/constants/api.constants";

class StationService {
  static async getStations(params = {}) {
    const response = await axiosInstance.get(API_PATHS.getstations, { params });
    return response.data;
  }

  static async getStationById(id) {
    const response = await axiosInstance.get(`admin/stations/${id}`);
    return response.data;
  }

  static async createStation(payload) {
    const response = await axiosInstance.post(API_PATHS.addstation, payload);
    return response.data;
  }

  static async bulkCreateStation(payload) {
    const response = await axiosInstance.post(
      API_PATHS.bulkcreatestation,
      payload
    );

    return response.data;
  }

  static async updateStation(id, payload) {
    const response = await axiosInstance.put(`admin/stations/${id}`, payload);
    return response.data;
  }

  static async deleteStation(id) {
    const response = await axiosInstance.delete(`admin/stations/${id}`);
    return response.data;
  }
}

export default StationService;